<div class="bn-dashboard-user-profile">
  <bn-web-ui-dropdown-menu
    #profileDropdown
    data-e2e="LayoutUserProfileMenu"
    [aboveLoader]="true"
    [items]="menuItems"
    [options]="
      isMobile
        ? {
            align: 'end',
            size: 'sm',
            attachArrow: true,
          }
        : {
            align: 'start',
            size: 'sm',
            indent: '-18px',
            attachArrow: true,
          }
    "
    (clickAction)="onItemClick($event)"
    (keydown.escape)="profileDropdown.isOpened && profileDropdown.toggleDropdown()">
    <span
      role="button"
      tabindex="0"
      trigger
      [attr.aria-label]="'User menu for ' + (fullName || email)"
      (keydown.enter)="profileDropdown.toggleDropdown()"
      (keydown.space)="$event.preventDefault(); profileDropdown.toggleDropdown()">
      <img
        alt=""
        email="{{ email }}"
        ngxGravatar
        [size]="isMobile ? 30 : 24" />
    </span>
    <div
      class="bn-dropdown"
      content-top>
      <div class="bn-dropdown__header">
        <div>
          @if (accountRoute) {
            <a
              class="text-200-semi-bold"
              [routerLink]="accountRoute"
              >{{ fullName }}</a
            >
          } @else {
            <span class="text-200-semi-bold">{{ fullName }}</span>
          }
        </div>
        <span
          class="user-select-auto"
          data-e2e="LayoutUserProfileCopyEmail"
          [title]="email + '\nClick to copy'"
          (click)="copyToClipboard()"
          >{{ email }}</span
        >
      </div>
      @if (showBilling) {
        <hr class="bn-dropdown__divider" />
        <div class="bn-dropdown__item">
          @if (billingRoute) {
            <a
              class="bn-dropdown__item-link"
              [routerLink]="billingRoute">
              <fa-icon
                class="bn-dropdown__icon"
                icon="circle-dollar" />
              <span>Billing</span>
              @if (billingBalance) {
                <bn-web-ui-badge
                  color="green"
                  contentClass="float-end"
                  size="xs"
                  >{{ billingBalance | currency }}</bn-web-ui-badge
                >
              }
            </a>
          }
        </div>
        <hr class="bn-dropdown__divider" />
      }
    </div>
  </bn-web-ui-dropdown-menu>
</div>
